import React from "react";
import { BsClipboard2DataFill } from "react-icons/bs";
import { MdOutlineTimelapse } from "react-icons/md";
import { FaBookmark, FaCheckCircle } from "react-icons/fa";
import { ProjectStatusCard } from "./ProjectStatusCard";
import { useHomePageContext } from "../context/HomePageContext";

/**
 * ProjectStatusCardsSection component - Self-contained status display
 * Following Clean Code principle: Zero props, uses context for data access
 */
export const ProjectStatusCardsSection: React.FC = () => {
  const { projectData } = useHomePageContext();

  return (
    <div className="mb-4 flex w-full flex-row divide-x divide-[#231F20]/10 rounded-lg bg-white px-2 shadow-md shadow-black/5">
      <ProjectStatusCard
        statusName="All Projects"
        value={projectData.totalCounts?.all}
        icon={<BsClipboard2DataFill />}
        iconBackground="bg-[#482F8B]/20"
      />
      <ProjectStatusCard
        statusName="Recommendations of Projects"
        value={projectData.totalCounts?.recommendations}
        icon={<MdOutlineTimelapse />}
        iconBackground="bg-[#FF6C37]/20"
      />
      <ProjectStatusCard
        statusName="Saved Projects"
        value={projectData.totalCounts?.saved}
        icon={<FaBookmark />}
        iconBackground="bg-[#CF3D96]/20"
      />
      <ProjectStatusCard
        statusName="Searched Projects"
        value={projectData.totalCounts?.searched}
        icon={<FaCheckCircle />}
        iconBackground="bg-[#81BD5B]/20"
      />
    </div>
  );
};
